import React from 'react';

import { connect } from 'react-redux';

import { Input } from '@nerdwallet/currency';

import { REFINANCE } from '../../../lib/analytics-constants';
import { validationsSelector } from '../../../lib/selectors';
import {
  manualInputsSelector,
  inputsSelector,
} from '../../../lib/selectors/refinance-calculator-selectors';
import {
  RefinanceInput,
  INPUT_TRACKING_TYPES,
  inputOnChange,
} from '../../../lib/utils';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

const MortgageOriginationYearInput: React.FC<RefinanceInput> = ({
  manualInputs,
  inputs,
  dispatch,
  analytics,
  validations,
  label = '',
  tooltip = '',
  className = '',
  fullWidth,
}) => {
  const value = manualInputs?.originationYear || '';
  const placeholder = inputs?.originationYear;
  const errorMessage = validations?.originationYear?.[0];
  const error = Boolean(errorMessage);
  const analyticsEnabled = analytics && analytics?.enabled;
  const legacyAnalytics =
    analyticsEnabled && analytics?.payload?.legacy?.formName;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (e: OnChangeEvent) => {
    let legacy;
    if (legacyAnalytics) {
      const legacyProps = analytics?.payload?.legacy;
      legacy = {
        ...legacyProps,
        fieldName: 'originationYear',
        inputType: INPUT_TRACKING_TYPES.TEXT,
      };
    }

    let bedrock;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_s',
      };
    }

    inputOnChange({
      event: e,
      // @ts-ignore - ignore error
      previousValue: value,
      dispatch,
      legacy,
      bedrock,
      fieldName: 'originationYear',
      calculator: REFINANCE,
      inputType: 'number',
    });
  };

  return (
    <Input
      inputMode="tel"
      value={value}
      placeholder={placeholder}
      error={error}
      errorMessage={errorMessage}
      onChange={onInputChange}
      className={className}
      label={label}
      tooltip={tooltip}
      fullWidth={fullWidth}
    />
  );
};

const mapStateToProps = (state) => ({
  manualInputs: manualInputsSelector(state),
  inputs: inputsSelector(state),
  validations: validationsSelector(state),
});

export default connect(mapStateToProps)(MortgageOriginationYearInput);
